export * from './search.component';